import { styled } from "@mui/material/styles";

const PaginationWrapper = styled("div")(({ theme }) => ({
  marginTop: "40px",
  "& ul": {
    justifyContent: "end",
  },
  "&  ul li:first-child": {
    "& button": {
      marginRight: "8px",
    },
  },
  "&  ul li:last-child": {
    "& button": {
      marginLeft: "8px",
    },
  },

  "& ul li button": {
    background: "#F4F4F4",
    borderRadius: "10px",
    minWidth: "36px",
    height: "36px",
    border: "none",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "15px",
    lineHeight: "18px",
    textAlign: "center",
    color: "rgba(11, 11, 11, 0.5)",
    fontFamily: theme.typography.fontFamily,
    margin: "0 5px",
  },
  "& ul li button.Mui-selected": {
    background: "#0B0B0B",
    color: "#fff",
    "&:hover": {
      background: "#0B0B0B",
    },
  },
}));
export { PaginationWrapper };
